import { SITE_DASHBOARD_LISTING, SITE_DETAIL, SITE_DASHBOARD_EXPORT_CSV } from "./type";

const initialState = {
  sitesList: {},
  siteDetail: null,
  exportCsv: { isExporting: false },
};

const siteDashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITE_DASHBOARD_LISTING:
      return {
        ...state,
        sitesList: payload,
      };
    case SITE_DETAIL:
      return {
        ...state,
        siteDetail: payload,
      };
    case SITE_DASHBOARD_EXPORT_CSV:
      return {
        ...state,
        exportCsv: {
          ...state.exportCsv,
          ...(payload || {}),
        },
      };
    default:
      return state;
  }
};

export default siteDashboardReducer;
